import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";
import MerchantTopupTableCopy from "./MerchantTopupTableCopy";
import { FiRefreshCcw } from "react-icons/fi";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const MerchantTopup1Copy = () => {

    const { callApi: fetchPendingRequest } = useApi("/admin/cashin/pending", "GET");
    const { callApi: approveRequest } = useApi("/admin/cashin/approve", "POST");
    const { callApi: rejectRequest } = useApi("/admin/cashin/reject", "POST");
    const { callApi: fetchPendingRequestBank } = useApi("/admin/cashin/pending/byBank", "GET");
    const { callApi: fetchBankCount } = useApi("/admin/cashin/pending/bank-count", "GET");
    const { callApi: walletbalance } = useApi("/admin/cashin/wallet/balance", "GET");
    const { callApi: checksrijipayBalance } = useApi("/admin/users/srijipay/check-balance", "POST");

    const [soliteckBalance, setSoliteckBalance] = useState("");
    const [soliteckBalanceLoading, setSoliteckBalanceLoading] = useState(false);

    const { callApi: checkSoliteckBalance } = useApi("/admin/users/soliteck/check-balance", "POST");

    const fetchSoliteckBalance = async () => {
        setSoliteckBalanceLoading(true);
        try {
            const res = await checkSoliteckBalance();
            if (res?.status === true) {
                setSoliteckBalance(res.balance);
            }
        } catch (err) {
            console.error("Soliteck Balance fetch failed", err);
        } finally {
            setSoliteckBalanceLoading(false);
        }
    };

    const { callApi: checktramoBalance } = useApi("/admin/users/tramo/check-balance", "GET");

    const [finzepBalance, setFinzepBalance] = useState("");
    const [finzepBalanceLoading, setFinzepBalanceLoading] = useState(false);

    const { callApi: checkfinzepBalance } = useApi("/admin/users/finzep/check-balance", "GET");

    const fetchfinzepBalance = async () => {
        setFinzepBalanceLoading(true);
        try {
            const res = await checkfinzepBalance();
            if (res?.status === 2 || res?.errorcode === "200") {
                setFinzepBalance(res.bal);
            }
        } catch (err) {
            console.error("Finzep Balance fetch failed", err);
        } finally {
            setFinzepBalanceLoading(false);
        }
    };

    const [finkedaBalance, setFinkedaBalance] = useState("");
    const [finkedaBalanceLoading, setFinkedaBalanceLoading] = useState(false);

    const { callApi: checkFinkedaBalance } = useApi("/pg/finkeda/balance", "GET");

    const fetchFinkedaBalance = async () => {
        setFinkedaBalanceLoading(true);
        try {
            const res = await checkFinkedaBalance();
            if (res?.operativeBalance !== undefined && res?.operativeBalance !== null) {
                setFinkedaBalance(Number(res.operativeBalance).toFixed(2));
            }
        } catch (err) {
            console.error("Finkeda Balance fetch failed", err);
        } finally {
            setFinkedaBalanceLoading(false);
        }
    };

    const userId = useSelector((state) => state.auth.employeeDetails.userId);
    const username = useSelector((state) => state.auth.employeeDetails.username);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [walletBalance, setWalletBalance] = useState(0);
    const [proofPopup, setProofPopup] = useState({ open: false, url: "" });
    const [amountInput, setAmountInput] = useState({});
    const [remarks, setRemarks] = useState({});
    const [loadingAction, setLoadingAction] = useState(false);
    const [bankCount, setBankCount] = useState([]);
    const [refreshing, setRefreshing] = useState(false);
    const [tpEnabled, setTpEnabled] = useState(false);
    const [message, setMessage] = useState({ text: "", type: "" });
    const [confirmPopup, setConfirmPopup] = useState({ open: false, type: "", row: null, index: null });
    const [otpPopup, setOtpPopup] = useState({ open: false, pendingPayload: null, sentTo: [] });
    const [otpInput, setOtpInput] = useState("");
    const [otpError, setOtpError] = useState("");
    const [otpLoading, setOtpLoading] = useState(false);
    const [mpin, setMpin] = useState("");
    const [selectedBank, setSelectedBank] = useState("");
    const [rotation, setRotation] = useState(0);
    const [activeTab, setActiveTab] = useState("pending");

    const adminId = userId;

    const refreshAllData = async () => {
        try {
            setRefreshing(true);
            await Promise.all([fetchRequests(), fetchBankCounts(), fetchWalletBalance()]);
            setRemarks({});
        } catch (err) {
            console.error(err);
        } finally {
            setRefreshing(false);
        }
    };

    const [showThresholdEditor, setShowThresholdEditor] = useState(false);

    const [thresholds, setThresholds] = useState(() => {
        const saved = localStorage.getItem("balance_thresholds");
        return saved ? JSON.parse(saved) : {
            aeron: "", nifi: "", dillipay: "", earthpay: "", indicore: "",
            instantpay: "", wallet: "", srijipay: "", tramo: "", finzep: "", finkeda: "", soliteck: ""
        };
    });

    useEffect(() => {
        localStorage.setItem("balance_thresholds", JSON.stringify(thresholds));
    }, [thresholds]);

    const isBelowThreshold = (balance, threshold) => {
        if (!threshold) return false;
        return Number(balance || 0) < Number(threshold);
    };

    const fetchBankCounts = async () => {
        try {
            const res = await fetchBankCount();
            console.log("Bank Count API Response:", res);
            if (Array.isArray(res)) {
                const formatted = {};
                res.forEach((bank) => {
                    const key = bank.bankName;
                    if (formatted[key]) {
                        formatted[key].pendingCount += bank.pendingCount;
                    } else {
                        formatted[key] = { bankName: bank.bankName, nickName: bank.nickName, pendingCount: bank.pendingCount };
                    }
                });
                setBankCount(Object.values(formatted));
            }
        } catch (error) {
            console.error("Bank Count Error:", error);
        }
    };

    const fetchWalletBalance = async () => {
        try {
            const res = await walletbalance(null, `?userName=${username}`);
            console.log("Wallet Balance:", res);
            if (res?.balance !== undefined) setWalletBalance(res.balance);
        } catch (error) {
            console.error("Wallet Balance Error:", error);
        }
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString.replace(" ", "T"));
        return date.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
    };

    const numberToWords = (num) => {
        const a = ["", "One ", "Two ", "Three ", "Four ", "Five ", "Six ", "Seven ", "Eight ", "Nine ",
            "Ten ", "Eleven ", "Twelve ", "Thirteen ", "Fourteen ", "Fifteen ", "Sixteen ",
            "Seventeen ", "Eighteen ", "Nineteen "];
        const b = ["", "", "Twenty ", "Thirty ", "Forty ", "Fifty ", "Sixty ", "Seventy ", "Eighty ", "Ninety "];
        const inWords = (n) => {
            if (n < 20) return a[n];
            if (n < 100) return b[Math.floor(n / 10)] + a[n % 10];
            if (n < 1000) return a[Math.floor(n / 100)] + "Hundred " + inWords(n % 100);
            if (n < 100000) return inWords(Math.floor(n / 1000)) + "Thousand " + inWords(n % 1000);
            if (n < 10000000) return inWords(Math.floor(n / 100000)) + "Lakh " + inWords(n % 100000);
            return inWords(Math.floor(n / 10000000)) + "Crore " + inWords(n % 10000000);
        };
        return inWords(num) + "Only";
    };

    const getAmountColor = (amount) => {
        if (amount >= 1000000) return "text-purple-700";
        if (amount >= 400000) return "text-red-600";
        return "text-black";
    };

    const getModeColor = (mode) => {
        if (mode === "Cash") return "text-green-600 font-semibold";
        if (mode === "CDM") return "text-blue-600 font-semibold";
        if (mode === "Online") return "text-indigo-600 font-semibold";
        return "";
    };

    const fetchRequests = async () => {
        try {
            setLoading(true);
            let res;
            if (selectedBank) {
                res = await fetchPendingRequestBank(null, `?bank_name=${selectedBank}`);
            } else {
                res = await fetchPendingRequest();
            }
            if (Array.isArray(res)) {
                const reversed = [...res].reverse();
                setData(reversed);
                const defaultAmounts = {};
                reversed.forEach((item, index) => { defaultAmounts[index] = item.amount; });
                setAmountInput(defaultAmounts);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const refreshAllBalances = async () => {
        await Promise.all([
            fetchBalance(), fetchnifiBalance(), fetchdillipayBalance(), fetchearthypayBalance(),
            fetchindicoreBalance(), fetchinstantpayBalance(), fetchsrijipayBalance(),
            fetchtramoBalance(), fetchfinzepBalance(), fetchFinkedaBalance(), fetchSoliteckBalance()
        ]);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === "pending") {
            fetchRequests();
            fetchBankCounts();
        }
    };

    useEffect(() => { fetchRequests(); fetchBankCounts(); }, [selectedBank]);
    useEffect(() => { fetchWalletBalance(); }, []);

    const handleConfirm = async () => {
        const { row, index, type } = confirmPopup;
        let approvePayload = null;
        try {
            setLoadingAction(true);
            let res;
            if (type === "approve") {
                approvePayload = { requestId: row.requestId, amount: amountInput[index], adminId, remarks: remarks[index], tp: tpEnabled, mpin,  mid: username };
                res = await approveRequest(approvePayload);
                setMessage({ text: res?.message || "Request Approved Successfully", type: "success" });
            } else {
                const payload = { requestId: row.requestId, adminId, remarks: remarks[index] };
                res = await rejectRequest(payload);
                setMessage({ text: res?.message || "Request Rejected Successfully", type: "error" });
            }
            fetchRequests();
            await refreshAllData();
            setTimeout(() => {
                setTpEnabled(false);
                setConfirmPopup({ open: false, type: "", row: null, index: null });
                setMessage({ text: "", type: "" });
            }, 1500);
        } catch (error) {
            if (type === "approve" && approvePayload) {
                const errData = error?.responseData || {};
                if (errData?.error_code === "OTP_REQUIRED" && errData?.action_params?.otpRequired === true) {
                    setOtpPopup({ open: true, pendingPayload: approvePayload, sentTo: errData.action_params?.sentTo || [] });
                    return;
                }
            }
            setMessage({ text: error?.message || "Something went wrong", type: "error" });
            setTimeout(() => {
                setConfirmPopup({ open: false, type: "", row: null, index: null });
                setMessage({ text: "", type: "" });
            }, 1000);
        } finally {
            setLoadingAction(false);
        }
    };

    const handleOtpSubmit = async () => {
        if (otpInput.length !== 6) { setOtpError("Please enter a valid 6-digit OTP"); return; }
        setOtpLoading(true);
        setOtpError("");
        try {
            const payload = { ...otpPopup.pendingPayload, otp: otpInput.trim() };
            const res = await approveRequest(payload);
            setOtpPopup({ open: false, pendingPayload: null, sentTo: [] });
            setOtpInput("");
            setMessage({ text: res?.message || "Request Approved Successfully", type: "success" });
            fetchRequests();
            await refreshAllData();
            setTimeout(() => {
                setTpEnabled(false);
                setConfirmPopup({ open: false, type: "", row: null, index: null });
                setMessage({ text: "", type: "" });
            }, 1500);
        } catch (error) {
            setOtpError(error?.message || "Invalid or expired OTP. Please try again.");
        } finally {
            setOtpLoading(false);
        }
    };

    const [balance, setBalance] = useState("");
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [nifiBalance, setnifiBalance] = useState("");
    const [nifiBalanceLoading, setnifiBalanceLoading] = useState(false);
    const [dillipayBalance, setdillipayBalance] = useState("");
    const [dillipayBalanceLoading, setdillipayBalanceLoading] = useState(false);
    const [earthypayBalance, setearthypayBalance] = useState("");
    const [earthypayBalanceLoading, setearthypayBalanceLoading] = useState(false);
    const [indicoreBalance, setindicoreBalance] = useState("");
    const [indicoreBalanceLoading, setindicoreBalanceLoading] = useState(false);
    const [instantpayBalance, setinstantpayBalance] = useState("");
    const [instantpayBalanceLoading, setinstantpayBalanceLoading] = useState(false);
    const [enkashBalance, setenkashBalance] = useState("");
    const [enkashBalanceLoading, setenkashBalanceLoading] = useState(false);
    const [srijipayBalance, setsrijipayBalance] = useState("");
    const [srijipayBalanceLoading, setsrijipayBalanceLoading] = useState(false);
    const [tramoBalance, settramoBalance] = useState("");
    const [tramoBalanceLoading, settramoBalanceLoading] = useState(false);

    const { callApi: checkBalanceApi } = useApi("/admin/users/aereon/check-balance", "POST");
    const { callApi: checkNifiBalance } = useApi("/admin/users/nifi/check-balance", "POST");
    const { callApi: checkdillipayBalance } = useApi("/admin/users/dillipay/check-balance", "POST");
    const { callApi: checkearthypayBalance } = useApi("/admin/users/earthpay/check-balance", "POST");
    const { callApi: checkindicoreBalance } = useApi("/admin/users/indicore/check-balance", "POST");
    const { callApi: checkinstantpayBalance } = useApi("/admin/users/instantpay/check-balance?latitude=20.1236&longitude=78.3228", "POST");
    const { callApi: checkenkashBalance } = useApi("/admin/users/enkash/check-balance", "POST");

    const fetchBalance = async () => {
        setBalanceLoading(true);
        try {
            const res = await checkBalanceApi();
            if (res?.status === "SUCCESS") setBalance(res.available_balance);
        } catch (err) { console.error("Balance fetch failed"); }
        finally { setBalanceLoading(false); }
    };

    const fetchnifiBalance = async () => {
        setnifiBalanceLoading(true);
        try {
            const res = await checkNifiBalance();
            if (res?.status === "success") setnifiBalance(res.data.balance);
        } catch (err) { console.error("Balance fetch failed"); }
        finally { setnifiBalanceLoading(false); }
    };

    const fetchdillipayBalance = async () => {
        setdillipayBalanceLoading(true);
        try {
            const res = await checkdillipayBalance();
            if (res?.status === "Success") setdillipayBalance(res.data.RunningBalance);
        } catch (err) { console.error("Balance fetch failed"); }
        finally { setdillipayBalanceLoading(false); }
    };

    const fetchearthypayBalance = async () => {
        setearthypayBalanceLoading(true);
        try {
            const res = await checkearthypayBalance();
            if (res?.status === "Success") setearthypayBalance(res.dataContent.Balance);
        } catch (err) { console.error("Balance fetch failed"); }
        finally { setearthypayBalanceLoading(false); }
    };

    const fetchsrijipayBalance = async () => {
        setsrijipayBalanceLoading(true);
        try {
            const res = await checksrijipayBalance();
            if (res?.status === "Success") setsrijipayBalance(res.data.RunningBalance);
        } catch (err) { console.error("Srijipay Balance fetch failed"); }
        finally { setsrijipayBalanceLoading(false); }
    };

    const fetchtramoBalance = async () => {
        settramoBalanceLoading(true);
        try {
            const res = await checktramoBalance();
            if (res?.status === "success") settramoBalance(res.data.walletBalance.toFixed(0));
        } catch (err) { console.error("Tramo Balance fetch failed"); }
        finally { settramoBalanceLoading(false); }
    };

    const fetchindicoreBalance = async () => {
        setindicoreBalanceLoading(true);
        try {
            const res = await checkindicoreBalance();
            console.log("Indicore Balance Response:", res);
            if (res?.status === true) {
                const responseParts = res?.response?.split("|");
                const balance = responseParts?.[1];
                setindicoreBalance(Number(balance).toFixed(2));
            }
        } catch (err) { console.error("Balance fetch failed", err); }
        finally { setindicoreBalanceLoading(false); }
    };

    const fetchinstantpayBalance = async () => {
        setinstantpayBalanceLoading(true);
        try {
            const res = await checkinstantpayBalance();
            if (res?.status === "Transaction Successful") setinstantpayBalance(res.data.balance.available);
        } catch (err) { console.error("Balance fetch failed"); }
        finally { setinstantpayBalanceLoading(false); }
    };

    const fetchenkashBalance = async () => {
        setenkashBalanceLoading(true);
        try {
            const res = await checkenkashBalance();
            if (res?.status === "Success") setenkashBalance(res.data.RunningBalance);
        } catch (err) { console.error("Balance fetch failed"); }
        finally { setenkashBalanceLoading(false); }
    };

    /* ─────────────────────────── RENDER ─────────────────────────── */

    const balanceCards = [
        { label: "Wallet",     val: walletBalance,     ld: false,                    thr: thresholds.wallet,     fn: fetchWalletBalance },
        { label: "Aeron",      val: balance,            ld: balanceLoading,           thr: thresholds.aeron,      fn: fetchBalance },
        { label: "Nifi",       val: nifiBalance,        ld: nifiBalanceLoading,       thr: thresholds.nifi,       fn: fetchnifiBalance },
        { label: "Dillipay",   val: dillipayBalance,    ld: dillipayBalanceLoading,   thr: thresholds.dillipay,   fn: fetchdillipayBalance },
        { label: "Earthpay",   val: earthypayBalance,   ld: earthypayBalanceLoading,  thr: thresholds.earthpay,   fn: fetchearthypayBalance },
        { label: "Indicore",   val: indicoreBalance,    ld: indicoreBalanceLoading,   thr: thresholds.indicore,   fn: fetchindicoreBalance },
        { label: "Instantpay", val: instantpayBalance,  ld: instantpayBalanceLoading, thr: thresholds.instantpay, fn: fetchinstantpayBalance },
        { label: "Srijipay",   val: srijipayBalance,    ld: srijipayBalanceLoading,   thr: thresholds.srijipay,   fn: fetchsrijipayBalance },
        { label: "Tramo",      val: tramoBalance,       ld: tramoBalanceLoading,      thr: thresholds.tramo,      fn: fetchtramoBalance },
        { label: "Finzep",     val: finzepBalance,      ld: finzepBalanceLoading,     thr: thresholds.finzep,     fn: fetchfinzepBalance },
        { label: "Finkeda",    val: finkedaBalance,     ld: finkedaBalanceLoading,    thr: thresholds.finkeda,    fn: fetchFinkedaBalance },
        { label: "Soliteck",   val: soliteckBalance,    ld: soliteckBalanceLoading,   thr: thresholds.soliteck,   fn: fetchSoliteckBalance },
    ];

    const TH = "border border-[#1E3A5A] px-2 py-1.5 text-left text-[12px] font-bold uppercase tracking-wide";

    const totalPending = bankCount.reduce((sum, b) => sum + (b.pendingCount || 0), 0);

    return (
        <div className="w-full space-y-3 pb-16">

            {/* ── TAB BAR ── */}
            <div className="flex gap-1 bg-white border border-[#D1D9E6] rounded-xl p-1 shadow-sm">
                <button
                    onClick={() => handleTabChange("pending")}
                    className={`flex-1 flex items-center justify-center gap-2 py-2 px-4 rounded-lg text-[13px] font-semibold transition ${
                        activeTab === "pending"
                            ? "bg-[#0A2A4F] text-white shadow-sm"
                            : "text-[#0A2A4F] hover:bg-[#F0F4FA]"
                    }`}
                >
                    Cash-In Pending
                    {totalPending > 0 && (
                        <span className={`text-[11px] font-bold rounded-full px-1.5 py-0.5 min-w-[20px] text-center ${
                            activeTab === "pending" ? "bg-white text-[#0A2A4F]" : "bg-red-500 text-white"
                        }`}>
                            {totalPending}
                        </span>
                    )}
                </button>
                <button
                    onClick={() => handleTabChange("history")}
                    className={`flex-1 flex items-center justify-center gap-2 py-2 px-4 rounded-lg text-[13px] font-semibold transition ${
                        activeTab === "history"
                            ? "bg-[#0A2A4F] text-white shadow-sm"
                            : "text-[#0A2A4F] hover:bg-[#F0F4FA]"
                    }`}
                >
                    Cash-In Report
                </button>
            </div>

            {/* ── TAB 1: CASH-IN PENDING REQUESTS ── */}
            {activeTab === "pending" && (
                <div className="space-y-4">

                    {/* ── PROVIDER BALANCES ── */}
                    <div className="bg-white border border-[#D1D9E6] rounded-xl overflow-hidden shadow-sm">

                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-3 border-b border-[#E5E7EB] bg-[#F8FAFC]">
                            <span className="text-[11px] font-medium text-[#0A2A4F] uppercase tracking-widest">Provider Balances</span>
                            <div className="flex items-center gap-2">
                                {/* temporary removed buttons for refresh and edit limits */}
                                {/* <button onClick={refreshAllBalances}
                                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#0A2A4F] text-white text-[12px] font-medium hover:bg-[#0d3566] transition">
                                    <FiRefreshCcw size={11} /> Refresh All
                                </button>
                                <button onClick={() => setShowThresholdEditor(!showThresholdEditor)}
                                    className="px-3 py-1.5 rounded-lg border border-[#0A2A4F]/30 text-[#0A2A4F] text-[12px] font-medium hover:bg-[#0A2A4F]/5 transition">
                                    {showThresholdEditor ? "Close" : "Edit Limits"}
                                </button> */}
                            </div>
                        </div>

                        {/* Threshold editor */}
                        {showThresholdEditor && (
                            <div className="px-4 py-3 border-b border-[#E5E7EB] bg-[#FAFBFC]">
                                <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-11 gap-2">
                                    {[
                                        { label: "Wallet",     key: "wallet" },
                                        { label: "Aeron",      key: "aeron" },
                                        { label: "Nifi",       key: "nifi" },
                                        { label: "Dillipay",   key: "dillipay" },
                                        { label: "Earthpay",   key: "earthpay" },
                                        { label: "Indicore",   key: "indicore" },
                                        { label: "Instantpay", key: "instantpay" },
                                        { label: "Srijipay",   key: "srijipay" },
                                        { label: "Tramo",      key: "tramo" },
                                        { label: "Finzep",     key: "finzep" },
                                        { label: "Finkeda",    key: "finkeda" },
                                        { label: "Soliteck",   key: "soliteck" },
                                    ].map(({ label, key }) => (
                                        <div key={key}>
                                            <p className="text-[10px] font-medium text-[#0A2A4F]/60 uppercase mb-1">{label}</p>
                                            <input type="number" value={thresholds[key] || ""}
                                                onChange={(e) => setThresholds({ ...thresholds, [key]: e.target.value })}
                                                placeholder="Min"
                                                className="w-full bg-white border border-[#E5E7EB] rounded-lg px-2 py-1 text-xs text-gray-700 outline-none focus:ring-2 focus:ring-[#0A2A4F]/20" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Balance cards */}
                        <div className="flex flex-wrap gap-3 px-4 py-4">
                            {balanceCards.map(({ label, val, ld, thr, fn }) => {
                                const below = isBelowThreshold(val, thr);
                                return (
                                    <div key={label} className={`flex items-center gap-0 rounded-xl min-w-[190px] border-2 overflow-hidden ${
                                        below ? "border-red-400 bg-red-50" : "border-[#93C5FD] bg-[#DBEAFE]"
                                    }`} style={{ boxShadow: "0 2px 8px rgba(10,42,79,0.10)" }}>
                                        <div className={`w-2 self-stretch flex-shrink-0 ${below ? "bg-red-400" : "bg-[#0A2A4F]"}`} />
                                        <div className="flex-1 min-w-0 px-3 py-3">
                                            <p className="text-[14px] font-semibold text-gray-500 leading-none mb-1.5 uppercase tracking-wider">{label}</p>
                                            <p className={`font-mono font-bold leading-tight text-[14px] ${below ? "text-[#DC2626]" : "text-[#0A2A4F]"}`}>
                                                {ld ? "···" : `₹${val || "0"}`}
                                            </p>
                                            {thr && <p className="text-[13px] text-gray-400 mt-1">Min ₹{thr}</p>}
                                        </div>
                                        <button onClick={fn} disabled={ld}
                                            className={`w-9 h-9 flex items-center justify-center rounded-lg mr-3 transition disabled:opacity-40 flex-shrink-0 ${
                                                below ? "bg-red-100 hover:bg-red-200 text-red-500" : "bg-white/60 hover:bg-white text-[#0A2A4F]"
                                            }`}>
                                            <FiRefreshCcw size={16} className={ld ? "animate-spin" : ""} />
                                        </button>
                                    </div>
                                );
                            })}

                            {/* Coming soon */}
                            {["Enkash", "Bill Avenue", "Chagans", "Urbanrupee", "Quick KYC", "Fingpay"].map(name => (
                                <div key={name} className="flex items-center gap-0 rounded-xl min-w-[175px] border-2 border-dashed border-[#CBD5E1] bg-[#F8FAFC] overflow-hidden opacity-60">
                                    <div className="w-2 self-stretch flex-shrink-0 bg-[#94A3B8]" />
                                    <div className="flex-1 min-w-0 px-3 py-3">
                                        <p className="text-[14px] font-semibold text-gray-400 leading-none mb-1.5 uppercase tracking-wider">{name}</p>
                                        <span className="inline-block px-2 py-0.5 rounded bg-[#E0E7FF] text-[#4338CA] text-[14px] font-semibold">Coming Soon</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ── BANK FILTER STRIP ── */}
                    <div className="bg-white border border-[#D1D9E6] rounded-xl px-5 py-4 flex flex-wrap justify-center items-center gap-3 shadow-sm">
                        <button
                            onClick={async () => { await fetchRequests(); await fetchBankCounts(); 
                                // await refreshAllBalances();
                             }}
                            disabled={loading}
                            className="w-11 h-11 flex items-center justify-center rounded-lg border border-[#E5E7EB] hover:bg-[#F0F4FA] transition text-[#0A2A4F] disabled:opacity-50 flex-shrink-0"
                            title="Refresh table"
                        >
                            <FiRefreshCcw size={20} className={loading ? "animate-spin" : ""} />
                        </button>

                        <div className="w-px h-8 bg-[#E5E7EB] flex-shrink-0" />

                        <button
                            onClick={() => setSelectedBank("")}
                            className={`px-5 py-2 rounded-lg text-[14px] font-semibold border transition ${
                                selectedBank === ""
                                    ? "bg-[#0A2A4F] text-white border-[#0A2A4F]"
                                    : "bg-white text-[#0A2A4F] border-[#D1D9E6] hover:border-[#0A2A4F]"
                            }`}
                        >All</button>

                        {bankCount?.map((bank) => (
                            <button
                                key={bank.bankName}
                                onClick={() => setSelectedBank(bank.bankName)}
                                className={`relative px-5 py-2 rounded-lg text-[14px] font-semibold border transition ${
                                    selectedBank === bank.bankName
                                        ? "bg-[#0A2A4F] text-white border-[#0A2A4F]"
                                        : "bg-white text-[#0A2A4F] border-[#D1D9E6] hover:border-[#0A2A4F]"
                                }`}
                            >
                                {bank.nickName}
                                {bank.pendingCount > 0 && (
                                    <span className="absolute -top-3 -right-3 bg-red-500 text-white text-[14px] font-bold rounded-full min-w-[32px] h-[32px] flex items-center justify-center px-1.5 leading-none">
                                        {bank.pendingCount}
                                    </span>
                                )}
                            </button>
                        ))}
                    </div>

                    {/* ── DESKTOP TABLE ── */}
                    <div className="hidden md:block bg-white border border-[#B0BFCF] rounded-xl shadow-sm" style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "auto" }}>
                        <table className="w-full border-collapse min-w-[1000px]">
                            <thead className="bg-[#0A2A4F] text-white sticky top-0 z-10">
                                <tr>
                                    <th className={`${TH} w-[210px]`}>User Details</th>
                                    <th className={`${TH} w-[175px]`}>Request Amount</th>
                                    <th className={`${TH} w-[185px]`}>Date</th>
                                    <th className={`${TH} w-[165px]`}>Mode & Bank</th>
                                    <th className={`${TH} w-[185px]`}>Txn Ref</th>
                                    <th className={`${TH} w-[175px]`}>Re-enter Amount</th>
                                    <th className={`${TH} w-[185px]`}>Admin Remarks</th>
                                    <th className={`${TH} w-[72px] text-center`}>Proof</th>
                                    <th className={`${TH} w-[155px] text-center`}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan="9" className="text-center py-10 text-[14px] text-gray-400">Loading...</td></tr>
                                ) : data.length > 0 ? (
                                    data.map((row, index) => (
                                        <tr key={index} className="hover:bg-[#EEF4FB] border-b border-[#C5D3E0] align-top">

                                            {/* USER */}
                                            <td className="border border-[#B0BFCF] px-2 py-1.5">
                                                <p className="font-bold text-[#0A2A4F] text-[13px] leading-snug">{row.shopName}</p>
                                                <p className="text-[12px] text-gray-600 mt-0.5">{row.name}</p>
                                                <p className="text-[12px] text-gray-400 mt-0.5">{row.mobile}</p>
                                                <p className="text-[11px] text-gray-400 mt-0.5">{row.role || "—"} · {row.district || "—"}</p>
                                            </td>

                                            {/* REQUEST AMOUNT */}
                                            <td className={`border border-[#B0BFCF] px-2 py-1.5 ${getAmountColor(row.amount)}`}>
                                                <p className="font-bold text-[13px]">₹{row.amount?.toLocaleString()}</p>
                                                <p className="text-[11px] text-gray-400 mt-0.5 leading-snug">{numberToWords(Math.floor(row.amount || 0))}</p>
                                            </td>

                                            {/* REQUEST TIME + DEPOSIT DATE */}
                                            <td className="border border-[#B0BFCF] px-2 py-1.5">
                                                <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Requested</p>
                                                <p className="text-[12px] font-semibold text-gray-800">{formatDateTime(row.requestTime)}</p>
                                                <div className="mt-1 pt-1 border-t border-[#C5D3E0]">
                                                    <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Deposit</p>
                                                    <p className="text-[12px] font-semibold text-gray-800">{row.depositDate || "—"}</p>
                                                </div>
                                            </td>

                                            {/* MODE + BANK */}
                                            <td className="border border-[#B0BFCF] px-2 py-1.5">
                                                <p className={`text-[13px] font-bold ${getModeColor(row.paymentMode)}`}>{row.paymentMode || "—"}</p>
                                                <p className="text-[12px] text-gray-700 mt-1 break-words leading-snug">{row.bankName || "—"}</p>
                                            </td>

                                            {/* TXN REF */}
                                            <td className="border border-[#B0BFCF] px-2 py-1.5 text-[12px] text-gray-700 break-words whitespace-normal leading-relaxed">
                                                {row.requesterRemarks || "—"}
                                            </td>

                                            {/* RE-ENTER AMOUNT */}
                                            <td className={`border border-[#B0BFCF] px-2 py-1.5 ${getAmountColor(amountInput[index])}`}>
                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    className="border border-[#B0BFCF] px-2 py-1 rounded-lg w-full text-[12px] outline-none focus:ring-2 focus:ring-[#0A2A4F]/20"
                                                    value={amountInput[index] || ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) setAmountInput({ ...amountInput, [index]: value });
                                                    }}
                                                />
                                                <p className="text-[12px] text-gray-400 mt-1">{numberToWords(Math.floor(amountInput[index] || 0))}</p>
                                            </td>

                                            {/* ADMIN REMARKS */}
                                            <td className="border border-[#B0BFCF] px-2 py-1.5">
                                                <input
                                                    type="text"
                                                    placeholder="Admin remarks"
                                                    className="border border-[#B0BFCF] px-2 py-1 rounded-lg w-full text-[12px] outline-none focus:ring-2 focus:ring-[#0A2A4F]/20"
                                                    value={remarks[index] || ""}
                                                    onChange={(e) => setRemarks({ ...remarks, [index]: e.target.value })}
                                                />
                                            </td>

                                            {/* PROOF */}
                                            <td className="border border-[#B0BFCF] px-2 py-1.5 text-center">
                                                <button
                                                    onClick={() => setProofPopup({ open: true, url: row.proofUrl })}
                                                    className="text-[#0A2A4F] underline text-[12px] font-semibold hover:text-blue-600"
                                                >View</button>
                                            </td>

                                            {/* ACTION */}
                                            <td className="border border-[#B0BFCF] px-2 py-1.5">
                                                <div className="flex flex-col gap-2">
                                                    <button
                                                        onClick={() => setConfirmPopup({ open: true, type: "approve", row, index })}
                                                        className="bg-green-600 hover:bg-green-700 text-white text-[12px] px-2 py-1.5 rounded-lg font-bold w-full"
                                                    >Approve</button>
                                                    <button
                                                        onClick={() => setConfirmPopup({ open: true, type: "reject", row, index })}
                                                        className="bg-red-500 hover:bg-red-600 text-white text-[12px] px-2 py-1.5 rounded-lg font-bold w-full"
                                                    >Reject</button>
                                                </div>
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="9" className="text-center py-12 text-[14px] text-gray-400">No Pending Requests</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* ── MOBILE CARDS ── */}
                    <div className="md:hidden space-y-3 pb-24">
                        {loading ? (
                            <div className="text-center py-10 text-gray-400">Loading...</div>
                        ) : data.length > 0 ? (
                            data.map((row, index) => (
                                <div key={index} className="bg-white border border-[#D1D9E6] rounded-xl shadow-sm overflow-hidden">
                                    <div className="bg-[#0A2A4F] px-4 py-3">
                                        <p className="text-white font-medium text-[14px] leading-snug">{row.shopName}</p>
                                        <p className="text-white/70 text-[12px]">{row.name} · {row.mobile}</p>
                                        <p className="text-white/50 text-[11px]">{row.role || "-"} · {row.district || "-"}</p>
                                    </div>
                                    <div className="px-4 py-3 space-y-3">
                                        <div className={`text-[18px] font-medium ${getAmountColor(row.amount)}`}>
                                            ₹{row.amount?.toLocaleString()}
                                            <span className="text-[11px] text-gray-400 font-normal ml-2">{numberToWords(Math.floor(row.amount || 0))}</span>
                                        </div>
                                        <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-[12px]">
                                            <div><p className="text-gray-400 text-[11px]">Request Time</p><p>{formatDateTime(row.requestTime)}</p></div>
                                            <div><p className="text-gray-400 text-[11px]">Deposit Date</p><p>{row.depositDate}</p></div>
                                            <div><p className="text-gray-400 text-[11px]">Mode</p><p className={getModeColor(row.paymentMode)}>{row.paymentMode}</p></div>
                                            <div><p className="text-gray-400 text-[11px]">Bank</p><p>{row.bankName || "-"}</p></div>
                                        </div>
                                        <div className="text-[12px]">
                                            <p className="text-gray-400 text-[11px]">Txn Ref</p>
                                            <p className="break-all">{row.requesterRemarks}</p>
                                        </div>
                                        <div>
                                            <p className="text-[11px] text-gray-400 uppercase tracking-wide mb-1">Re-enter Amount</p>
                                            <input
                                                type="number"
                                                className="border border-[#E5E7EB] px-3 py-2 rounded-lg w-full text-[13px] outline-none focus:ring-2 focus:ring-[#0A2A4F]/20"
                                                value={amountInput[index] || ""}
                                                onChange={(e) => setAmountInput({ ...amountInput, [index]: e.target.value })}
                                            />
                                            <p className="text-[10px] text-gray-400 mt-0.5">{numberToWords(Math.floor(amountInput[index] || 0))}</p>
                                        </div>
                                        <div>
                                            <p className="text-[11px] text-gray-400 uppercase tracking-wide mb-1">Admin Remarks</p>
                                            <input
                                                type="text"
                                                placeholder="Admin remarks"
                                                className="border border-[#E5E7EB] px-3 py-2 rounded-lg w-full text-[13px] outline-none focus:ring-2 focus:ring-[#0A2A4F]/20"
                                                value={remarks[index] || ""}
                                                onChange={(e) => setRemarks({ ...remarks, [index]: e.target.value })}
                                            />
                                        </div>
                                        <button
                                            onClick={() => setProofPopup({ open: true, url: row.proofUrl })}
                                            className="text-[#0A2A4F] underline text-[12px]"
                                        >View Proof</button>
                                        <div className="flex gap-2 pt-1">
                                            <button
                                                onClick={() => setConfirmPopup({ open: true, type: "approve", row, index })}
                                                className="flex-1 bg-green-600 text-white py-2.5 rounded-xl text-[13px] font-medium"
                                            >Approve</button>
                                            <button
                                                onClick={() => setConfirmPopup({ open: true, type: "reject", row, index })}
                                                className="flex-1 bg-red-500 text-white py-2.5 rounded-xl text-[13px] font-medium"
                                            >Reject</button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center py-10 text-gray-400">No Pending Requests</div>
                        )}
                    </div>

                    {/* ── CONFIRM POPUP ── */}
                    {confirmPopup.open && (
                        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                            <div className="bg-white rounded-2xl shadow-2xl p-7 w-[500px] max-w-[95vw] border border-gray-200">
                                {!message.text && !loadingAction && (
                                    <>
                                        <h3 className="text-xl font-bold text-[#0A2A4F] mb-2">
                                            {confirmPopup.type === "approve" ? "Approve Cash-In Request" : "Reject Cash-In Request"}
                                        </h3>
                                        <p className="text-sm text-gray-500 mb-5">
                                            {confirmPopup.type === "approve" ? "Please review the details before approving this request." : "This action cannot be undone."}
                                        </p>
                                        {confirmPopup.type === "approve" && (
                                            <div className="mb-5 rounded-2xl border border-green-200 bg-gradient-to-r from-green-50 to-emerald-50 p-5">
                                                <div className="flex items-center justify-between">
                                                    <div>
                                                        <h4 className="font-semibold text-gray-800">Apply TP Fee</h4>
                                                        <p className="text-sm text-gray-500 mt-1">Enable TP fee deduction while approving.</p>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => setTpEnabled(!tpEnabled)}
                                                        className={`relative inline-flex h-8 w-14 items-center rounded-full transition-all duration-300 ${tpEnabled ? "bg-green-600" : "bg-gray-300"}`}
                                                    >
                                                        <span className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition-all duration-300 ${tpEnabled ? "translate-x-7" : "translate-x-1"}`} />
                                                    </button>
                                                </div>
                                                <div className="mt-4">
                                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${tpEnabled ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>
                                                        {tpEnabled ? "✓ TP Fee Enabled" : "Normal Approval Flow"}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                        {confirmPopup.type === "approve" && (
                                            <div className="mb-5">
                                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                    MPIN <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="password"
                                                    maxLength={6}
                                                    value={mpin}
                                                    onChange={e => setMpin(e.target.value.replace(/\D/g, ""))}
                                                    placeholder="Enter MPIN"
                                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-gray-800 font-semibold tracking-widest text-center text-lg"
                                                />
                                            </div>
                                        )}
                                        <div className="flex justify-end gap-3 mt-6">
                                            <button
                                                onClick={() => { setTpEnabled(false); setMpin(""); setConfirmPopup({ open: false, type: "", row: null, index: null }); }}
                                                className="px-5 py-2.5 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium"
                                            >Cancel</button>
                                            <button
                                                onClick={handleConfirm}
                                                className={`px-5 py-2.5 rounded-xl text-white font-semibold ${confirmPopup.type === "approve" ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"}`}
                                            >{confirmPopup.type === "approve" ? "Approve Request" : "Reject Request"}</button>
                                        </div>
                                    </>
                                )}
                                {loadingAction && (
                                    <div className="flex flex-col items-center py-8">
                                        <div className="w-12 h-12 border-[5px] border-green-500 border-t-transparent rounded-full animate-spin"></div>
                                        <p className="mt-4 text-sm font-medium text-gray-600">Processing Request...</p>
                                    </div>
                                )}
                                {message.text && !loadingAction && (
                                    <div className={`text-center py-6 text-base font-semibold ${message.type === "success" ? "text-green-600" : "text-red-600"}`}>
                                        {message.text}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* ── OTP POPUP ── */}
                    {otpPopup.open && (
                        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-2xl shadow-2xl w-[460px] max-w-[95vw] border border-gray-200 overflow-hidden">

                                {/* Header */}
                                <div className="bg-[#0A2A4F] px-6 py-4 flex items-center justify-between">
                                    <h3 className="text-[17px] font-bold text-white tracking-wide">OTP Verification</h3>
                                    <button
                                        onClick={() => { setOtpPopup({ open: false, pendingPayload: null, sentTo: [] }); setOtpInput(""); setOtpError(""); setConfirmPopup({ open: false, type: "", row: null, index: null }); }}
                                        disabled={otpLoading}
                                        className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-lg leading-none disabled:opacity-40"
                                    >×</button>
                                </div>

                                {/* Body */}
                                <div className="px-6 py-5">
                                    <p className="text-sm text-gray-600 mb-3">
                                        OTP has been sent to the registered approver. Enter the 6-digit OTP to continue.
                                    </p>
                                    {otpPopup.sentTo?.length > 0 && (
                                        <div className="flex flex-wrap gap-2 mb-4">
                                            <span className="text-xs text-gray-400 font-medium self-center">OTP sent to:</span>
                                            {otpPopup.sentTo.map((num, i) => (
                                                <span key={i} className="px-3 py-1 rounded-full bg-[#EFF6FF] border border-[#BFDBFE] text-[#0A2A4F] text-sm font-semibold">
                                                    {num}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                    <div className="mb-1">
                                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                                            Enter 6-digit OTP
                                        </label>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={6}
                                            value={otpInput}
                                            onChange={(e) => { setOtpInput(e.target.value.replace(/\D/g, "").slice(0, 6)); setOtpError(""); }}
                                            onKeyDown={(e) => e.key === "Enter" && handleOtpSubmit()}
                                            placeholder="_ _ _ _ _ _"
                                            className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 text-2xl tracking-[0.6em] text-center font-bold text-[#0A2A4F] outline-none focus:border-[#0A2A4F] transition placeholder:text-gray-300 placeholder:tracking-[0.6em]"
                                            disabled={otpLoading}
                                            autoFocus
                                        />
                                        <p className={`text-xs mt-1 text-right font-medium ${otpInput.length === 6 ? "text-green-600" : "text-gray-400"}`}>
                                            {otpInput.length} / 6
                                        </p>
                                    </div>
                                    {otpError && (
                                        <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg px-3 py-2 mt-2 mb-1">
                                            <span className="text-red-500 text-base leading-none">⚠</span>
                                            <p className="text-sm text-red-600 font-medium">{otpError}</p>
                                        </div>
                                    )}
                                </div>

                                {/* Footer */}
                                <div className="px-6 pb-5 flex gap-3">
                                    <button
                                        onClick={() => { setOtpPopup({ open: false, pendingPayload: null, sentTo: [] }); setOtpInput(""); setOtpError(""); setConfirmPopup(prev => ({ ...prev, open: true, type: "reject" })); }}
                                        disabled={otpLoading}
                                        className="flex-1 px-4 py-2.5 rounded-xl bg-red-50 hover:bg-red-100 border border-red-200 text-red-600 font-semibold text-sm disabled:opacity-50 transition"
                                    >Reject</button>
                                    <button
                                        onClick={handleOtpSubmit}
                                        disabled={otpLoading || otpInput.length !== 6}
                                        className="flex-1 px-4 py-2.5 rounded-xl bg-green-600 hover:bg-green-700 text-white font-semibold text-sm disabled:opacity-50 flex items-center justify-center gap-2 transition"
                                    >
                                        {otpLoading ? (
                                            <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />Verifying…</>
                                        ) : <>✓ Approve</>}
                                    </button>
                                </div>

                            </div>
                        </div>
                    )}

                    {/* ── PROOF POPUP ── */}
                    {proofPopup.open && (
                        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
                            <div className="relative bg-white rounded-xl shadow-2xl w-[90vw] h-[90vh] flex flex-col overflow-hidden">
                                <TransformWrapper>
                                    {({ zoomIn, zoomOut, resetTransform }) => (
                                        <>
                                            <div className="flex justify-between items-center border-b border-[#E5E7EB] px-4 py-3 bg-white flex-shrink-0">
                                                <h3 className="font-medium text-[#0A2A4F] text-[15px]">Payment Proof</h3>
                                                <div className="flex items-center gap-1.5">
                                                    <button onClick={() => setRotation(p => p - 90)} className="px-2.5 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-[12px]">⟲</button>
                                                    <button onClick={() => setRotation(p => p + 90)} className="px-2.5 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-[12px]">⟳</button>
                                                    <button onClick={() => zoomIn()} className="px-2.5 py-1.5 bg-[#EFF6FF] hover:bg-[#DBEAFE] text-[#0A2A4F] rounded-lg text-[12px]">+</button>
                                                    <button onClick={() => zoomOut()} className="px-2.5 py-1.5 bg-[#EFF6FF] hover:bg-[#DBEAFE] text-[#0A2A4F] rounded-lg text-[12px]">−</button>
                                                    <button onClick={() => { resetTransform(); setRotation(0); }} className="px-2.5 py-1.5 bg-amber-50 hover:bg-amber-100 text-amber-700 rounded-lg text-[12px]">Reset</button>
                                                    <button onClick={() => setProofPopup({ open: false, url: "" })} className="px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white rounded-lg text-[12px]">Close</button>
                                                </div>
                                            </div>
                                            <div className="flex-1 flex items-center justify-center overflow-hidden p-4 bg-[#F8FAFC]">
                                                <TransformComponent>
                                                    <div style={{ transform: `rotate(${rotation}deg)` }}>
                                                        <img src={proofPopup.url} alt="proof" className="max-h-[70vh] max-w-full object-contain rounded-lg" />
                                                    </div>
                                                </TransformComponent>
                                            </div>
                                        </>
                                    )}
                                </TransformWrapper>
                            </div>
                        </div>
                    )}

                </div>
            )}

            {/* ── TAB 2: CASH-IN REPORT ── */}
            {activeTab === "history" && (
                <MerchantTopupTableCopy />
            )}

        </div>
    );
};

export default MerchantTopup1Copy;
